import createReducer from './createReducer';
import {
  FETCH_FORECAST,
  FETCH_FORECAST_SUCCESS,
  FETCH_FORECAST_FAILURE,
  FORECAST_PRINT_VERSION,
  CLOSE_FORECAST_HEADER_ALERT,
  FORECAST_HEADER_ALERT_STATUS,
} from '../actions/forecast';

const initialState = {
  loading: false,
  printVersion: false,
  forecast: {},
  interval: 360,
  hasFetched: 0,
  forecastHeaderAlert: true,
};

const handlers = {};

handlers[FETCH_FORECAST] = state => ({
  ...state,
  loading: true,
  hasFetched: state.hasFetched + 1,
});

handlers[FETCH_FORECAST_SUCCESS] = (state, { forecast, interval }) => ({
  ...state,
  loading: false,
  forecast,
  interval,
});

handlers[FETCH_FORECAST_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FORECAST_PRINT_VERSION] = (state, { printVersion }) => ({
  ...state,
  printVersion,
});

handlers[CLOSE_FORECAST_HEADER_ALERT] = state => ({
  ...state,
  forecastHeaderAlert: false,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/forecast.js